import { toast } from "react-toastify";

export default function messageBox({
  message,
  type,
  time,
}: {
  message: string;
  type: "success" | "error" | "warning" | "info";
  time?: number;
}) {
  return toast[type](message, {
    position: "top-right",
    autoClose: time ? time : 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}
